<script setup lang="ts">
const { t } = useI18n()
import type { PartnerParameter } from '@/types/types'

const props = defineProps<{ selectedPartner: PartnerParameter }>()
const partnerHowToUrl = computed(() => {
  switch (props.selectedPartner?.partner?.slug) {
    case 'laddition':
      return 'https://heypongohelp.zendesk.com/hc/fr/articles/22297398555665-J-active-l-int%C3%A9gration-Hey-Pongo-sur-tablette-avec-ma-caisse-L-addition'
    case 'tillersystems':
      return 'https://heypongohelp.zendesk.com/hc/fr/articles/22966616220433-La-fid%C3%A9lit%C3%A9-sans-contact-avec-SumUp'
    default:
      return props.selectedPartner?.howToUrl
  }
})
</script>

<template>
  <div
    class="sticky left-0 top-0 z-10 flex w-full flex-col items-center justify-between gap-2 rounded-b-sm bg-white px-10 py-3 xl:flex-row"
  >
    <div class="mt-2 flex items-center gap-3">
      <img
        class="aspect-square w-20 rounded-md border bg-white object-contain p-2"
        :src="selectedPartner?.partner?.logo"
      />
      <div>
        <h2 class="mb-1 text-lg font-semibold capitalize">{{ selectedPartner?.partner?.name }}</h2>
        <p class="text-sm text-muted-foreground">{{ t('pages.loyalty.create.addSoftware') }}</p>
      </div>
    </div>
    <a
      v-if="partnerHowToUrl"
      :href="partnerHowToUrl"
      target="_blank"
      class="flex cursor-pointer items-center gap-2 text-sm font-semibold text-primary underline hover:text-primary/80"
    >
      <p>{{ t('pages.loyalty.create.help') }}</p>
      <BaseIcon name="HeroArrowTopRightOnSquareIconOutline" class="h-5 w-5" />
    </a>
  </div>
</template>
